// apiConfig.js
const BASE_URL = "http://essentialsapi.antheminfotech.com";

// const BASE_URL = "https://localhost:7208";

export default BASE_URL;